module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_51.66e50660.png";